module.exports = __webpack_public_path__ + "static/media/calendar.1557e316.svg";